import React, { useEffect } from "react";
import Select, { SingleValue } from "react-select";
import { darkModeStepperNav } from "../../../../utils/constants";
import { useDarkModeStore } from "../../../../store/useDarkModeStore";
import { useLanguageStore } from "../../../../store/useLanguageStore";
import useCompany from "../../../../store/ReactQueries/general/company/useCompany";

interface SelectCompanyProps {
    value: any;
    label: string;
    companyId: string;
    viewMode?: boolean;
    handleCompany: (selectedOption: SingleValue<{
        label: any;
        value: string;
    }>) => void;
    setValue: (value: any) => void
}

const SelectCompany = ({
    label, value, companyId, viewMode = false,
    setValue, handleCompany
}: SelectCompanyProps) => {
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore()

    const { data: companies } = useCompany(0, 0);

    useEffect(() => {
        if (!companyId && companies?.length) {
            const hasDefaultCompanies = companies.find(item => item.isDefault);
            console.log('hasDefaultCompanies', hasDefaultCompanies);

            const defaultCompanyId = hasDefaultCompanies ? hasDefaultCompanies.id : companyId;

            if (value?.companyId !== defaultCompanyId) {
                value
                    ? setValue({ ...value, companyId: defaultCompanyId })
                    : setValue({ companyId: defaultCompanyId });
            }
        }
    }, [companyId, companies, value, setValue]);

    const labelName = companies?.find((item: any) => item.id === companyId)?.title ?? '';

    const renderInViewMode = () => {
        return <div className={`d-flex flex-row gap-1 align-items-center ${darkMode && 'text-white'}`}>
            <span style={{ fontSize: 12 }}>{language['Company']}:</span>
            <span className="fw-bold" style={{ fontSize: 12 }}>{labelName}</span>
        </div>
    }

    const renderEditMode = () => {
        return <div className='w-100 mt-2 position-relative'>
            <label
                className={darkMode ? 'text-white' : 'text-muted'}
                style={{
                    top: -7,
                    left: 10,
                    zIndex: 100,
                    fontSize: 12,
                    padding: '0 5px',
                    fontWeight: 'bold',
                    position: 'absolute',
                    color: darkMode ? 'white' : '#a4a4a4',
                    background: darkMode ? darkModeStepperNav : 'white',
                }}
            >
                {language[label] ?? label}
            </label>
            <Select
                value={{ label: labelName, value: companyId }}
                className={`${darkMode && "dark-mode-input"}`}
                onChange={handleCompany}
                placeholder="Zgjedh"
                options={companies?.map((item: any) => ({
                    value: item.id ?? "",
                    label: item.title ?? '',
                }))}
                styles={{
                    menu: (provided) => ({ ...provided, zIndex: 11 }),
                    container: (provided) => ({
                        ...provided,
                        position: "relative",
                        zIndex: 11,
                    }),
                    singleValue: (provided) => ({
                        ...provided,
                        color: darkMode ? 'white' : 'black',
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 11 }),
                    control: (provided) => ({
                        ...provided,
                        backgroundColor: darkMode ? darkModeStepperNav : "white",
                        borderColor: darkMode ? '#585858' : "initial",
                        height: 50
                    }),
                }}
                menuPlacement="top"
                menuPortalTarget={document.body}
            />
        </div>
    }

    return viewMode
        ? renderInViewMode()
        : renderEditMode();
}

export default SelectCompany;